import * as React from 'react';
import { Component } from '../../lib/component';
import barsWhite from '../../static/bars-white.svg';
import barsBrand from '../../static/bars-brand.svg';
import {classes, style} from 'typestyle';
import {centerCenter} from 'csstips';

export interface LoadingProps {
  className?: string;
  light?: boolean;
  size?: number;
}

export class Loading extends Component<LoadingProps> {
  render() {
    const { size = 48, className, light } = this.props;
    const style = { width: size };

    return (
      <div className={classes(Loading.styles.container, className)}>
        <img src={light ? barsWhite : barsBrand} style={style}/>
      </div>
    )
  }

  static styles = {
    container: style({
      ...centerCenter,
      position: 'relative',
    })
  }
}